import { GameStatues, IGame } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import server from "../Server";
import { GameType } from "../../../../../src/screens/new-game/NewGame.types";

interface CreateGamePayload2 {
  groupId: number;
  location: string;
  notes: string;
  datetime: Date;
  game_type: GameType;
  host_team_name: string;
  visitor_team_name: string;
  playing_as_host: boolean;
  season_id: number | null;
  organization_id: number | null;
}

export const CreateGame = async (payload: CreateGamePayload2): Promise<Omit<IGame, "group" | "attendees">> => {
  //@ts-ignore
  return withErrorCheck(
    await server
      .from("Games")
      .insert({
        group_id: payload.groupId,
        location: payload.location,
        notes: payload.notes,
        datetime: payload.datetime.toISOString(),
        status: GameStatues.SCHEDULED,
        host_team_name: payload.host_team_name,
        visitor_team_name: payload.visitor_team_name,
        game_type: payload.game_type,
        playing_as_host: payload.playing_as_host,
        season_id: payload.season_id,
        organization_id: payload.organization_id
      })
      .select()
  )[0];
};
